import React from 'react';

import AlertBanner from '~/components/core/AlertBanner';

import PromotionReasonsNote from './PromotionReasonsNote';
import type { PromotionExportBlocked } from './promotionsUtils';

interface PromotionExportBlockedBannerProps {
  exportBlocked: PromotionExportBlocked;
}

/** The in-dialog notice for a request refused with 422 PROMOTION_EXPORT_BLOCKED: the summary, then one row per
 * offender. A preview normally leaves a blocked section out instead (see `BlockedSectionGroup`); this remains the
 * fallback for an older cross-deployment target that still refuses the whole preview, and approve's answer when
 * the target's export of a section the promotion writes is blocked (approve never applies a section without a
 * rollback snapshot of it). Shared by the create dialogs and the incoming detail dialog. */
const PromotionExportBlockedBanner: React.FC<PromotionExportBlockedBannerProps> = ({ exportBlocked }) => (
  <AlertBanner
    withIcon
    alertType={AlertBanner.ALERT_TYPES.WARNING}
    title="This organization's configuration can't be exported yet"
    note={<PromotionReasonsNote message={exportBlocked.message} reasons={exportBlocked.reasons} />}
  />
);

export default PromotionExportBlockedBanner;
